import { useQuery } from '@tanstack/react-query'

import type { AuthProviderItem, AuthSession, AuthIdentity, AuthUser } from '@/lib/api-types'
import { requestJson, requestPublicJson } from '@/lib/api'

export const authQueryKeys = {
  providers: ['auth', 'providers'] as const,
  me: ['auth', 'me'] as const,
}

export function useAuthProvidersQuery() {
  return useQuery({
    queryKey: authQueryKeys.providers,
    queryFn: () =>
      requestPublicJson<{ providers: AuthProviderItem[] }>('/v1/auth/providers', {
        cachePolicy: 'stable-metadata',
      }),
    refetchOnMount: 'always',
    staleTime: 10 * 60 * 1000,
    meta: {
      persist: 'global',
    },
  })
}

export async function fetchAuthMe() {
  return requestJson<{
    user: AuthUser
    identity: AuthIdentity
    session: AuthSession
  }>('/v1/auth/me')
}
